<template>
  <b-modal
    id="select-delivery-area-modal"
    ref="select-delivery-areaalert-modal"
    size="sm"
    centered
    :hide-header="false"
    :hide-footer="true"
    v-model="showDeliveryAreaSelector"
    :title="_T('Select Delivery Area')"
    :no-close-on-backdrop="true"
  >
    <div class="select-delivery-area-modal" role="document">
      <div class="modalcontent">
        <div class="modalbody ratio_portrait">
           <select-delivery-area-form ref="selectDAForm" />
        </div>
      </div>
      <div class="modal-footer">
        <div class="footer-container">
          <button class="btn btn-solid btn-block mt-0" @click="selectDA">OK</button>
          <a href="#" @click.prevent="useGoogleMaps">Use google maps?</a>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import selectDeliveryAreaForm from '@/components/SelectDeliveryAreaForm'
export default {
  name: 'selectDeliveryArea',
  components: {
    selectDeliveryAreaForm
  },
   
  computed: {
    ...mapGetters(['_T', '_T_DB', 
    'selectedDeliveryAreaOption',
    'brand_all_delivery_areas_being_loaded',
    ]),
    
    showDeliveryAreaSelector() {
      if (this.brand_all_delivery_areas_being_loaded) {
        return false
      }
      return !['googleMaps', 'daSelected'].includes(this.selectedDeliveryAreaOption)
    },
     
  },
  methods: {
    useGoogleMaps() {
      this.$store.commit('SET_SELECT_DELIVERY_AREA_OPTION', 'googleMaps')
    },
    selectDA() {
      this.$refs.selectDAForm.selectDA()
    }
  }
}
</script>
<style lang="scss" scoped>
.select-delivery-area-modal {
  .footer-container {
    display: flex;
    flex-flow: column wrap;
    align-content: space-between;
    width: 100%;
    button, a {
      text-align: center;
    }
    a {
      margin-top: 1rem;
    }
  }
  select {
    width: 100%;
    cursor: pointer;
     
  }
}

</style>

 